export default __webpack_public_path__ + "static/media/sent-plane.fa106915.webp";